import { LinkKnownFile } from "../../components/LinkKnownFile";
import BorderAllIcon from "@mui/icons-material/BorderAll";
import DescriptionIcon from "@mui/icons-material/Description";
import CodeIcon from "@mui/icons-material/Code";
import { AnchorHTMLAttributes, DetailedHTMLProps } from "react";
import { AMapperResolverFile } from "./resolver";

type Props = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & { fileType: AMapperResolverFile["fileType"] };

export const FileComponent = (props: Props) => {
  const { fileType, ...rest } = props;

  // if (fileType === "image") {
  //   return <Image src={rest.href} alt="Image to be described" />;
  // }

  if (fileType === "docx") {
    return (
      <LinkKnownFile {...rest} target="_blank" rel="noreferrer">
        <DescriptionIcon fontSize="small" /> Document
      </LinkKnownFile>
    );
  }

  if (fileType === "spreadsheet") {
    return (
      <LinkKnownFile {...rest} target="_blank" rel="noreferrer">
        <BorderAllIcon fontSize="small" /> Spreadsheet
      </LinkKnownFile>
    );
  }

  if (fileType === "pdf") {
    return (
      <LinkKnownFile {...rest} target="_blank" rel="noreferrer">
        <DescriptionIcon fontSize="small" /> PDF Document
      </LinkKnownFile>
    );
  }

  if (fileType === "csv") {
    return (
      <LinkKnownFile {...rest} target="_blank" rel="noreferrer">
        <BorderAllIcon fontSize="small" /> CSV File
      </LinkKnownFile>
    );
  }

  if (fileType === "html") {
    return (
      <LinkKnownFile {...rest} target="_blank" rel="noreferrer">
        <CodeIcon fontSize="small" /> HTML File
      </LinkKnownFile>
    );
  }

  return null;
};
